export const TRIAL = 'TRIAL';
export const ACTIVE = 'ACTIVE';
export const TRIAL_ENDED = 'TRIAL_ENDED';
export const INACTIVE = 'INACTIVE';
